import { render, staticRenderFns } from "./poster-1.vue?vue&type=template&id=2729fd3d&scoped=true&"
import script from "./poster-1.vue?vue&type=script&lang=js&"
export * from "./poster-1.vue?vue&type=script&lang=js&"
import style0 from "./poster-1.vue?vue&type=style&index=0&id=2729fd3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2729fd3d",
  null
  
)

export default component.exports